import { z } from "zod";
import { NineBoxCellIdSchema } from "./nineBox.ts";
import { CyclePersonSchema } from "./reviewCycleSchemas.ts";
import { CycleReviewTypes } from "./reviewTypes.ts";
import { ScoreDistributionSchema } from "./scoreDistribution.ts";

export const CycleCalibrationSummarySchema = z.object({
    overall: ScoreDistributionSchema,
    performance: ScoreDistributionSchema,
    potential: ScoreDistributionSchema,
    cycle: ScoreDistributionSchema,
    gap: z.number().nullable()
});

export type CycleCalibrationSummary = z.infer<typeof CycleCalibrationSummarySchema>;

const CycleScoreAnswerSchema = z.object({
    questionId: z.string(),
    reviewType: z.enum(CycleReviewTypes),
    value: z.number()
});

export type CycleScoreAnswer = z.infer<typeof CycleScoreAnswerSchema>;

export const CycleCalibrationRevieweeSchema = z.object({
    member: CyclePersonSchema,
    jobTitle: z.string().optional(),
    departmentLabel: z.string().optional(),
    overallScore: z.number().nullable(),
    performanceScore: z.number().nullable(),
    potentialScore: z.number().nullable(),
    cellId: NineBoxCellIdSchema.nullable(),
    canWriteNote: z.boolean()
});

export type CycleCalibrationReviewee = z.infer<typeof CycleCalibrationRevieweeSchema>;

const CycleBenchmarkDimensions = ["department", "job-title"] as const;

const CycleBenchmarkSchema = z.object({
    dimension: z.enum(CycleBenchmarkDimensions),
    label: z.string(),
    average: z.number().nullable(),
    delta: z.number().nullable()
});

export type CycleBenchmark = z.infer<typeof CycleBenchmarkSchema>;
export type CycleBenchmarkDimension = CycleBenchmark["dimension"];

export const CycleCalibrationEvidenceSchema = z.object({
    benchmarks: z.array(CycleBenchmarkSchema),
    answers: z.array(CycleScoreAnswerSchema)
});

export type CycleCalibrationEvidence = z.infer<typeof CycleCalibrationEvidenceSchema>;

export const CycleCalibrationNoteSchema = z.object({
    content: z.string(),
    isAvailable: z.boolean()
});

export type CycleCalibrationNote = z.infer<typeof CycleCalibrationNoteSchema>;
